import React from 'react';
import PropTypes from 'prop-types';
import { FaX } from 'react-icons/fa6';

const HelpModal = ({ isVisible, onClose }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
      <div className="bg-white p-8 rounded-lg shadow-lg w-[95%]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold">Help</h2>
          <button onClick={onClose}>
            <FaX className="text-gray-600 text-2xl cursor-pointer" />
          </button>
        </div>
        <ul className="list-disc pl-5">
          <li>To open folders, click on the icons.</li>
          <li>Click the red button on the top right to close a window.</li>
          <li>Pinned applications are available for quick access.</li>
          <li>Click on the help button for assistance anytime.</li>
          <li className="flex items-center text-black rounded bg-yellow-300 p-2 mt-2">
            <span className="text-md">For optimal experience, please view this site on desktop or large devices.</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

HelpModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default HelpModal;
